export default "__VITE_ASSET__ZeIE3eEi__"